/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Жүктелуде...',
	'dlg_close': 'Жабу',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Болдырмау',
	'dlg_back': 'Қайту',

	// Slider
	'sliderRegionLabel': 'Жүгірткі басқаруы, жүгірткі таңбалауыштарын жылжыту үшін оң және сол жақ көрсеткілерін қолданыңыз',
	'sliderHandleLabel': 'Жүгірткі таңбалауышы',
	'a11ySliderHandleLabel': 'Жүгірткі таңбалауышы %{sliderValue}',
	'sliderInputLabel': 'мән',

	// Side bar
	'sidebarAdd': 'Қосу',
	'clearTextFilterValue': 'Тазалау',
	'missingDataSetData': 'Бұл деректер жиыны үшін деректер қолжетімсіз келеді. Көзге қатынас үшін әкімшіңізге қатынас орнатыңыз немесе деректер жиыныңызды жаңартыңыз.',

	// Toolbar
	'toolbarRegionLabel': 'Құралдар тақтасы',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Қаріп жиынтығы',
	'fontSizeSelect': 'Қаріп өлшемі',
	'bold': 'Қалың',
	'italic': 'Көлбеу',
	'underline': 'Астын сызу',
	'justifyLeft': 'Сол жақ бойынша туралау',
	'justifyCenter': 'Ортасы бойынша туралау',
	'justifyRight': 'Оң жақ бойынша туралау',
	'insertOrderedList': 'Реттестірілген тізім',
	'insertUnorderedList': 'Реттестірілмеген тізім',
	'fontColorPicker': 'Түс таңдағыш',
	'textWrap': 'Тасымалдау мәтіні',
	'restore': 'Әдепкі параметрлерді қайта сақтау',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Нәтижелер саны',
	'topbottomPercentLabel': 'Пайыз',
	'topbottomNumberOfResultsLimit': 'Мән %{lower} - %{higher} болуы керек',
	'topbottomSelectOption': 'Жоғарғы немесе төменгі опция',
	'topbottomOptionLabel': 'Көрсету',
	'searchByLabel': 'Арқылы',
	'searchNoMatches': 'Сәйкестіктер табылған жоқ',
	'topbottomRankColumnLabel': 'Кестеге дәреже бағанын қосыңыз',
	'topbottomNone': 'Ешбір',
	'topCount': 'Жоғарғы санақ',
	'topPercent': 'Жоғарғы %',
	'bottomCount': 'Төменгі санақ',
	'bottomPercent': 'Төменгі %',
	'searchColumn': 'Бағанды табу',
	'searchColumnAriaLabel': 'Бағанды табу. Тізім ішінде бағанды табу үшін содан кейін төменгі көрсеткі пайдалану үшін іздеу баған атауын теріп енгізіңіз',
	'rankColumnLabel': 'Дәреже (%{columnLabel})',
	'topbottomClearLabel': 'Тазалау',

	// Format
	'formatAuto': 'Авто',
	'formatConvertPercent': 'Ондықты пайызға түрлендіріңіз',
	'formatAbbreviate': 'Аббревиатура',
	'formatUseGrouping': 'Мыңдықтар бөлгішін пайдалану',
	'dateStyle': 'Күн мәнері',
	'dateTimeStyle': 'Күн/Уақыт мәнері',
	'formatMissingValueCharactersInfo': 'Жетіспейтін мән таңбалары, егер ешқандай мән болмаса, көрсетілетін таңбаларды білдіреді.',
	'currencySymbolLabel': 'Валюта белгісі',
	'customSymbolPlaceholder': 'Таңба қосыңыз',
	'customSymbolLabelInfo': 'Жеке таңба ретінде пайдаланылатын таңбаны немесе таңбаларды анықтайды. Бұл таңба сан мен кез келген белгінің алдында болады.',
	'numberLabel': 'Нөмір белгісі',
	'numberPositionLabel': 'Белгі орны',
	'numberLabelInfo': 'Пішімделген нөмір үшін белгіні белгілейді және затбелгі орнына байланысты префикс немесе суффикс ретінде орналастырылады.',
	'nullValueDefault': '<әдепкі>',
	'nullValueContent': '(мәні жоқ)',
	'default': 'Әдепкі',
	'beginning': 'Басы',
	'end': 'Соңы',

	// More data indicator
	'moreDataIndicator': 'Сіздің дерегіңіз %{threshold} элементтерінде қиылды. Сүзгіні аз көрсету үшін қабылдаңыз.',

	// Expanded View / Focus mode
	'evCollapse': 'Тасалау',
	'duplicate': 'Көшірмелеу',
	'copyOf': '%{name} көшірмесі',
	'unableToDuplicateBoard': '"%{name}" көшірмелеу мүмкін емес.',

	// Widget list
	'errorLoadingWidgetList': 'Бұл нысандарды жүктей алмаймыз.',

	// Custom widgets
	'customWidget': 'Тұтыну виджеті'
});
